module.exports = __webpack_public_path__ + "static/istock-624617308-compressor-df86d1b63ed4719724e716aed098c6e8.jpg";